var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.85 7.42501C13.85 3.87648 10.9735 1 7.42501 1C3.87648 1 1 3.87648 1 7.42501C1 10.9735 3.87648 13.85 7.42501 13.85",
    stroke: "#201D1D",
    strokeWidth: 1.17636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06508 1.03223C8.06508 1.03223 9.99258 3.57011 9.99258 7.42511M6.78008 13.818C6.78008 13.818 4.85257 11.2801 4.85257 7.42511C4.85257 3.57011 6.78008 1.03223 6.78008 1.03223M1.40234 9.67386H7.42258M1.40234 5.17636H13.4428",
    stroke: "#201D1D",
    strokeWidth: 1.17636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7751 11.2264C14.0925 11.4217 14.0726 11.8965 13.7462 11.9338L12.0969 12.1208L11.3574 13.6062C11.2109 13.9011 10.7579 13.7566 10.6827 13.3916L9.87639 9.46209C9.81278 9.15369 10.0903 8.95966 10.3583 9.12478L13.7751 11.2264Z",
    stroke: "#201D1D",
    strokeWidth: 1.17636
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.dc398b4742c78e7dcc56426d2c5cf359.svg";
export { ForwardRef as ReactComponent };